import { useMutation, useQuery } from '@apollo/client';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { ADD_RENDER_QUEUE, TEAMS } from '../../api/GraphQL';
import Column from '../ui/Column';
import Button from '../ui/form/Button';
import Input from '../ui/form/Input';
import Panel from '../ui/Panel';
import Row from '../ui/Row';

function Create() {
  const history = useHistory();
  const { data: teams } = useQuery(TEAMS);
  const [addRenderQueue, { data, loading, error }] = useMutation(
    ADD_RENDER_QUEUE,
    {
      refetchQueries: ['RenderQueues'],
      onCompleted: () => {
        history.push('/render-queues');
      },
    }
  );
  const [name, setName] = useState('');
  const [members, setMembers] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState();

  return (
    <Row>
      <Panel title={'Create Render Queue'} border_title={true}>
        <Column size="12">
          <Row>
            <Column size="4">
              <Input
                id="new_name"
                label={'Name'}
                placeholder={'Render Queue Name'}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </Column>
          </Row>
          <Row>
            <Column size="4">
              <select
                onChange={(e) => {
                  setSelectedTeam(
                    teams?.teams?.find((u) => u?._id === e.currentTarget.value)
                  );
                }}
              >
                <option selected={!selectedTeam}>Select team</option>
                {teams?.teams
                  ?.filter(
                    (u) => members?.findIndex((m) => m?._id === u._id) === -1
                  )
                  .map((team) => {
                    return (
                      <option
                        value={team?._id}
                        selected={selectedTeam?._id === team?._id}
                      >
                        {team.name}
                      </option>
                    );
                  })}
              </select>
              {selectedTeam && (
                <Button
                  label="Add to team"
                  onClick={() => {
                    setMembers([...members, selectedTeam]);
                    setSelectedTeam();
                  }}
                />
              )}
            </Column>
          </Row>
          <Row>
            {members?.map((member) => {
              return (
                <Row>
                  <Button
                    label="Remove"
                    onClick={() => {
                      let new_members = [...members];
                      new_members = new_members?.filter(
                        (m) => m?._id !== member?._id
                      );
                      setMembers(new_members);
                      setSelectedTeam();
                    }}
                  />
                  {member?.name}{' '}
                </Row>
              );
            })}
          </Row>
          <Row>
            <Column size={12}>
              <Button
                primary
                label={'Create New Render Queue'}
                onClick={() => {
                  addRenderQueue({
                    variables: {
                      name,
                      teams: members?.map((m) => m?._id),
                    },
                  });
                }}
              />
            </Column>
          </Row>
        </Column>
      </Panel>
    </Row>
  );
}

export default Create;
